import React from 'react';

export function SlettetInformasjonsboks({
	vis,
	tekst,
}: {
	vis: boolean;
	tekst?: string;
}) {
	if (!vis) return null;
	return (
		<div className="slettet-informasjonsboks">
			<p>{tekst || 'Informasjon har blitt slettet fra dette punktet.'}</p>
		</div>
	);
}
